import {STATES} from 'common/domain/states';
import removeModalBackdrop from 'common/utils/removeModalBackdrop';

export default class AppCtrl {
  constructor($window, $log, visitedPagesService, networkService, AuthenticationService, $state) {
    'ngInject';
    this.window = $window;
    this.log = $log;
    this.visitedPagesService = visitedPagesService;
    this.networkService = networkService;
    this.authenticationService = AuthenticationService;
    this.state = $state;
  }

  $postLink() {
    this._setOnWindowPopstate();

    if (this.window.innerWidth < 1024) {
      this._setAppOverflow();
      this._setMinHeight();
      this.networkService.run();
      this.configureBackButton();
      this.configureMobileAccessibility();
    }
  }

  showApp() {
    const isAuthenticated = this.authenticationService.isAuthenticated();
    const isAuthentication = this.state.current.name === STATES.AUTHENTICATION;
    const isError = this.state.current.name === STATES.ERROR;
    const isNotAllowed = this.state.current.name === STATES.NOT_ALLOWED;
    const isDevWeb = process.env.isDev;
    return isAuthenticated || isAuthentication || isError || isNotAllowed || isDevWeb;
  }

  configureBackButton() {
    document.addEventListener('backbutton', () => this.onBackKeyDown(), false);
  }

  onBackKeyDown() {
    if (this.visitedPagesService.shouldExitApp()) {
      navigator.app.exitApp();
    } else {
      this.visitedPagesService.subtractPageToCounter();
      navigator.app.backHistory();
    }
  }

  configureMobileAccessibility() {
    if (this.window.MobileAccessibility) {
      this.window.MobileAccessibility.usePreferredTextZoom(false);
      this.log.info('Mobile accessibility plugin available: disabling preferred text zoom.');
    } else {
      this.log.warn('Mobile accessibility plugin not available.');
    }
  }

  _setOnWindowPopstate() {
    $(window).on('popstate', () => {
      removeModalBackdrop();
    });
  }

  _setAppOverflow() {
    angular.element('html').css('overflow-x', 'hidden');
    angular.element('body').css('overflow-x', 'hidden');
  }

  _setMinHeight() {
    angular.element('body').css('min-height', '100vh');
  }
}



// WEBPACK FOOTER //
// ./client/app/app.controller.js